import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './hooks/useTheme';

// Import styles
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/themes.css';
import './styles/custom.css';

// Import components
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/common/Layout';
import Dashboard from './components/supplies/Dashboard';
import PurchaseDashboard from './components/purchase/Dashboard';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router future={{ 
          v7_startTransition: true,
          v7_relativeSplatPath: true 
        }}>
          <div className="App">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/supplies/*" element={
                <ProtectedRoute requiredDepartment="Supplies">
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/purchase/*" element={
                <ProtectedRoute requiredDepartment="Purchase">
                  <Layout>
                    <PurchaseDashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
